import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewerComponent } from './viewer/viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [ViewerComponent],
  exports: [ViewerComponent],
  imports: [MaterialModule, CommonModule, PdfViewerModule],
})
export class ViewpdfModule {}
